import { Box, Typography } from '@mui/material';
import { ISelectedDate, PeriodEnum } from 'common/defines/clients';
import { generateComparedTime } from 'common/utils/time';
import moment from 'moment';
import { FC } from 'react';

interface FilterDateProps {
  selectedPeriod: PeriodEnum;
  setSelectedDate: (arg: ISelectedDate) => void;
  setSelectedPeriod: (arg: PeriodEnum) => void;
}

const FilterDate: FC<FilterDateProps> = ({ selectedPeriod, setSelectedDate, setSelectedPeriod }) => {
  const listDateOption = [
    PeriodEnum.ONE_MONTH,
    PeriodEnum.SIX_MONTHS,
    PeriodEnum.TWELVE_MONTHS,
    PeriodEnum.MONTH_TO_DATE,
    PeriodEnum.YEAR_TO_DATE,
  ].map((item) => ({
    value: item,
    label: item,
  }));

  const handleSelectPeriod = (item: { value: PeriodEnum; label: PeriodEnum }) => {
    setSelectedPeriod(item.value);
    const startDate = generateComparedTime(item.value);
    setSelectedDate({ startDate: startDate.toISOString(), endDate: moment().toISOString() });
  };

  return (
    <Box display="flex" gap="12px">
      {listDateOption.map((item) => (
        <Box key={item.value} sx={{ padding: '4px', cursor: 'pointer' }} onClick={() => handleSelectPeriod(item)}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '18px',
              borderBottom: (theme) =>
                selectedPeriod === item.value ? `3px solid ${theme.palette.primary.main}` : undefined,
            }}>
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default FilterDate;
